export const ITEM_TINT_MIN = 0;
export const ITEM_TINT_MAX = 1;
export const ITEM_TINT_DISPLAY_MIN = 0;
export const ITEM_TINT_DISPLAY_MAX = 100;
